import dayjs from 'dayjs'
import { Text, TextProps, Tooltip, TooltipProps } from '.'

export interface Props extends Omit<TextProps, 'children'> {
  children: number | string
  tooltipProps?: TooltipProps
}

/** Pretty a date/time value to show time for today or a date otherwise wrapped in a tooltip */
export default function DateOrTime({ children, tooltipProps, ...rest }: Props) {
  if (!children) return null

  const date = dayjs(children)
  const today = dayjs()
  const isToday = date.isSame(today, 'day')
  const isThisYear = date.isSame(today, 'year')

  const display = isToday
    ? date.format('hh:mm A')
    : date.format(`MMM D${isThisYear ? '' : ', YYYY'}`)
  const tooltip = isToday ? `Today at ${date.format('hh:mm a')}` : date.format('hh:mm A')

  return (
    <Tooltip content={tooltip} {...(tooltipProps as any)}>
      <Text {...(rest as any)}>{display}</Text>
    </Tooltip>
  )
}
